/**
 * Checklist step domain entity.
 * Represents a step in a case checklist.
 * NOTE: ID fields use string type to support encrypted UUIDs
 */
export class ChecklistStepEntity {
  public id!: string;
  public caseId!: string;
  public checklistId!: string;
  public checklistName!: string;
  public stepName!: string;
  public stepDescription!: string;
  public sortOrder!: number;
  public isCompleted!: boolean;
  public completedByUserId!: string | null;
  public completedByUserName!: string | null;
  public completedOn!: string | null;
}
